import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { OggettoIntervento } from '../../../models/oggetto-intervento.model';
import { Bacino } from '../../../models/bacino.model';
import { Comune } from '../../../models/comune.model';
import { Accessibilita } from '../../../models/accessibilita.model';
import { NGXLogger } from 'ngx-logger';
import { StiliService } from '../../../services/stili.service';
import { SchedeService } from '../../../services/schede.service';
import { BaciniService } from '../../../services/bacini.service';
import { ComuniService } from '../../../services/comuni.service';
import { Scheda } from '../../../models/scheda.model';
import { CodiceATO } from '../../../models/codice-ato.model';
import { CodiceAtoDb } from '../../../models/codice-ato-db.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';

@Component({
  selector: 'app-modifica-scheda',
  templateUrl: './modifica-scheda.component.html',
  styleUrls: ['./modifica-scheda.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    InputNumberModule,
    CalendarModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [MessageService, SchedeService, BaciniService, ComuniService],
})
export class ModificaSchedaComponent implements OnInit, AfterViewInit {
  @ViewChild('dialog') dialog!: ElementRef;
  @Output() schedaModificata = new EventEmitter<Scheda>();
  @Output() ricaricaSchede = new EventEmitter<void>();

  visible: boolean = false;
  schedaForm!: FormGroup;
  scheda: Scheda | null = null;
  codiciAto: CodiceATO[] = [];
  codiciAtoFiltrati: CodiceATO[] = [];
  codiciAtoDb: CodiceAtoDb[] = [];
  oggettiIntervento: OggettoIntervento[] = [];
  bacini: Bacino[] = [];
  comuni: Comune[] = [];
  accessibilita: Accessibilita[] = [];
  submitting: boolean = false;

  annoCorrente: number = new Date().getFullYear();
  anni: number[] = [];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private logger: NGXLogger,
    private schedeService: SchedeService,
    public stiliService: StiliService,
    private baciniService: BaciniService,
    private comuniService: ComuniService,
    private firebaseStorageService: FirebaseStorageService,
  ) {
    this.schedaForm = this.fb.group({
      bacino: [null, Validators.required],
      comune: [{ value: null, disabled: true }, Validators.required],
      rioLocalita: [''],
      nuovoCodiceAto: [{ value: null, disabled: true }, Validators.required],
      codiceAto: [null],
      oggettoIntervento: [null, Validators.required],
      frequenza: [1],
      accessibilita: [null],
      note: [''],
      annoUltimoIntervento: [null],
      annoProssimoIntervento: [null],
      importoUltimoIntervento: [null],
    });

    // Aggiungiamo un listener al campo bacino per abilitare/disabilitare il campo comune
    this.schedaForm.get('bacino')?.valueChanges.subscribe((value) => {
      const comuneControl = this.schedaForm.get('comune');
      if (value) {
        comuneControl?.enable();
      } else {
        comuneControl?.disable();
        comuneControl?.setValue(null);
      }
    });

    // Aggiungiamo un listener al campo oggettoIntervento per abilitare/disabilitare il campo nuovoCodiceAto
    this.schedaForm
      .get('oggettoIntervento')
      ?.valueChanges.subscribe((value) => {
        const nuovoCodiceAtoControl = this.schedaForm.get('nuovoCodiceAto');
        if (value) {
          // Filtriamo i codici ATO in base all'oggetto selezionato
          this.codiciAtoFiltrati = this.codiciAto.filter((nuovoCodiceAto) => {
            const match = value.codiciAto.some((codiceObj: any) => {
              const result = codiceObj.codice === nuovoCodiceAto.codice;
              return result;
            });
            return match;
          });

          nuovoCodiceAtoControl?.enable();
        } else {
          this.codiciAtoFiltrati = [];
          nuovoCodiceAtoControl?.disable();
          nuovoCodiceAtoControl?.setValue(null);
        }
      });

    // Aggiungiamo un listener al campo bacino per filtrare i comuni
    this.schedaForm.get('bacino')?.valueChanges.subscribe((bacino) => {
      if (bacino) {
        this.filtraComuniPerBacino(bacino.id);
      } else {
        this.comuni = [];
        this.schedaForm.get('comune')?.setValue(null);
      }
    });
  }

  ngOnInit() {
    this.schedaForm = this.fb.group({
      bacino: [null, Validators.required],
      comune: [{ value: null, disabled: true }, Validators.required],
      rioLocalita: [''],
      nuovoCodiceAto: [{ value: null, disabled: true }, Validators.required],
      codiceAto: [null],
      oggettoIntervento: [null, Validators.required],
      frequenza: [1],
      accessibilita: [null],
      note: [''],
      annoUltimoIntervento: [null],
      annoProssimoIntervento: [null],
      importoUltimoIntervento: [null],
    });

    // Aggiungiamo un listener al campo bacino per abilitare/disabilitare il campo comune
    this.schedaForm.get('bacino')?.valueChanges.subscribe((value) => {
      const comuneControl = this.schedaForm.get('comune');
      if (value) {
        comuneControl?.enable();
      } else {
        comuneControl?.disable();
        comuneControl?.setValue(null);
      }
    });

    // Aggiungiamo un listener al campo oggettoIntervento per abilitare/disabilitare il campo nuovoCodiceAto
    this.schedaForm
      .get('oggettoIntervento')
      ?.valueChanges.subscribe((value) => {
        const nuovoCodiceAtoControl = this.schedaForm.get('nuovoCodiceAto');
        if (value) {
          // Filtriamo i codici ATO in base all'oggetto selezionato
          this.codiciAtoFiltrati = this.codiciAto.filter((codiceAto) => {
            return value.codiciAto.some((codiceObj: any) => {
              return codiceObj.codice === codiceAto.codice;
            });
          });

          // Se c'era un codice ATO selezionato, verifichiamo se è ancora valido
          const currentValue = nuovoCodiceAtoControl?.value;
          if (
            currentValue &&
            !this.codiciAtoFiltrati.some(
              (c) => c.codice === currentValue.codice,
            )
          ) {
            nuovoCodiceAtoControl?.setValue(null);
          }

          nuovoCodiceAtoControl?.enable();
        } else {
          this.codiciAtoFiltrati = [];
          nuovoCodiceAtoControl?.disable();
          nuovoCodiceAtoControl?.setValue(null);
        }
      });
  }

  ngAfterViewInit() {
    if (this.dialog) {
      this.dialog.nativeElement.addEventListener(
        'keydown',
        (event: KeyboardEvent) => {
          if (event.key === 'Escape') {
            this.hide();
          }
        },
      );
    }
  }

  show(scheda: Scheda) {
    this.scheda = { ...scheda };
    this.logger.info(this.scheda);
    this.visible = true;
    this.caricaDatiDiRiferimento();

    // Popola il form con i dati della scheda
  }

  hide() {
    this.visible = false;
    this.scheda = null;
    this.resetForm();
  }

  private resetForm(): void {
    this.schedaForm.reset();
    this.scheda = null;
    this.codiciAto = [];
    this.codiciAtoFiltrati = [];
    this.codiciAtoDb = [];
    this.oggettiIntervento = [];
    this.bacini = [];
    this.comuni = [];
    this.accessibilita = [];
    this.submitting = false;
  }

  private caricaDatiDiRiferimento(): void {
    forkJoin({
      bacini: this.baciniService.getBacini(),
      comuni: this.comuniService.get(),
      oggettiIntervento: this.schedeService.getOggettiIntervento(),
      codiciAto: this.schedeService.getCodiciAto(),
      codiciAtoDb: this.schedeService.getCodiciAtoDb(),
      livelliAccessibilita: this.schedeService.getLivelliAccessibilita(),
    }).subscribe({
      next: ({
        bacini,
        comuni,
        oggettiIntervento,
        codiciAto,
        codiciAtoDb,
        livelliAccessibilita,
      }) => {
        this.bacini = bacini;
        this.comuni = comuni;
        this.oggettiIntervento = oggettiIntervento;
        this.codiciAto = codiciAto;
        this.codiciAtoDb = codiciAtoDb;
        this.accessibilita = livelliAccessibilita;

        const comuneCorrispondente = this.comuni.find(
          (c) => c.id === this.scheda?.comune?.id,
        );
        const oggettoCorrispondente = this.oggettiIntervento.find(
          (o) => o.id === this.scheda?.oggettoIntervento?.id,
        );
        if (oggettoCorrispondente) {
          this.codiciAtoFiltrati = this.codiciAto.filter((codiceAto) =>
            oggettoCorrispondente.codiciAto.some(
              (codiceObj: any) => codiceObj.codice === codiceAto.codice,
            ),
          );
        }
        const codiceAtoCorrispondente =
          this.codiciAtoFiltrati.find(
            (c) => c.codice === this.scheda?.nuovoCodiceAto?.codice,
          ) ?? null;

        this.schedaForm.patchValue({
          bacino: this.scheda?.bacino,
          comune: comuneCorrispondente,
          rioLocalita: this.scheda?.rioLocalita,
          oggettoIntervento: oggettoCorrispondente,
          nuovoCodiceAto: codiceAtoCorrispondente,
          codiceAto:
            this.codiciAtoDb.find((c) => c.id === this.scheda?.codiceAto?.id) ??
            null,
          frequenza: this.scheda?.frequenza,
          accessibilita: this.scheda?.accessibilita,
          note: this.scheda?.note,
          annoUltimoIntervento: this.scheda?.annoUltimoIntervento
            ? new Date(this.scheda.annoUltimoIntervento, 0, 1)
            : null,
          annoProssimoIntervento: this.scheda?.annoProssimoIntervento
            ? new Date(this.scheda.annoProssimoIntervento, 0, 1)
            : null,
          importoUltimoIntervento: this.scheda?.importoUltimoIntervento,
        });

        this.logger.info(
          '[MODIFICA SCHEDA] Dati caricati, codiciAtoDb:',
          this.codiciAtoDb.length,
        );
      },
      error: (err) => {
        this.logger.error(
          '[MODIFICA SCHEDA] Errore durante il caricamento dei dati di riferimento:',
          err,
        );
      },
    });
  }

  private filtraComuniPerBacino(bacinoId: number): void {
    this.comuniService.get().subscribe((tuttiComuni) => {
      this.comuni = tuttiComuni.filter((comune) =>
        comune.bacini.some((bacino) => bacino.id === bacinoId),
      );
      this.logger.info(
        '[MODIFICA SCHEDA] Comuni filtrati per bacino:',
        this.comuni.length,
      );

      // Se il comune attualmente selezionato non appartiene al nuovo bacino, lo deselezioniamo
      const comuneAttuale = this.schedaForm.get('comune')?.value;
      if (
        comuneAttuale &&
        !this.comuni.some((c) => c.id === comuneAttuale.id)
      ) {
        this.schedaForm.get('comune')?.setValue(null);
      }
    });
  }

  salvaModifiche() {
    if (this.scheda && this.schedaForm.valid) {
      const schedaModificata = {
        ...this.scheda,
        ...this.schedaForm.value,
      };
      if (this.schedaForm.value.annoUltimoIntervento) {
        schedaModificata.annoUltimoIntervento =
          this.schedaForm.value.annoUltimoIntervento.getFullYear();
      }
      if (this.schedaForm.value.annoProssimoIntervento) {
        schedaModificata.annoProssimoIntervento =
          this.schedaForm.value.annoProssimoIntervento.getFullYear();
      }
      this.logger.info(schedaModificata);
      this.schedeService.modifica(schedaModificata).subscribe({
        next: (schedaAggiornata: Scheda) => {
          this.logger.info(
            '[MODIFICA SCHEDA] Scheda modificata con successo:',
            schedaAggiornata,
          );
          this.schedaModificata.emit(schedaAggiornata ?? (schedaModificata as Scheda));
          this.ricaricaSchede.emit();
          this.resetForm();
          this.hide();
        },
        error: (error: Error) => {
          this.logger.error(
            '[MODIFICA SCHEDA] Errore durante la modifica della scheda:',
            error,
          );
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore durante la modifica della scheda',
          });
          this.submitting = false;
          this.resetForm();
          this.hide();
        },
      });
    }
  }

  // Metodo per gestire il cambio di anno
  onYearChange(field: string, event: any) {
    if (event) {
      this.schedaForm.get(field)?.setValue(event.getFullYear());
    } else {
      this.schedaForm.get(field)?.setValue(null);
    }
  }
}
